<template>
	<div class="chat-helper-st-container">
		<div class="chat-helper-st-sender">
			<div class="chat-helper-stsr-title">
				<div class="chat-helper-stsr-desc">模拟推送内容：共<span>&nbsp;{{msgCounterInfo.groupCount}}&nbsp;</span>个分组<span>&nbsp;{{msgCounterInfo.msgCount}}&nbsp;</span>条消息</div>
				<div class="chat-helper-stsr-reset"><button @click="reset()">重置参数</button></div>
			</div>
			<div class="chat-helper-stsr-msg-box">
				<div class="chat-helper-stsr-msg"  id="chat-helper-stsr-msg">
					<div v-for="(messages,key,gIndex) in msgListWithGroup">
						<div class="chat-helper-srm-item" v-for="(msg,index) in messages">
							<div class="chat-helper-srm-group" :class="'chat-helper-srm-group-'+gIndex">
								<div class="chat-helper-srmg-name">{{key}}</div>
								<div class="chat-helper-srmg-select" @click="selectGroup($event,key,index)">分组</div>
							</div>
							<div class="chat-helper-srm-avatar"></div>
							<div class="chat-helper-srm-box">
								<div class="chat-helper-srm-info" v-html="$options.filters.formatMsg(msg.content,msg.type)"></div>	
								<div class="chat-helper-srm-del" @click="delMsg(key,index)"></div>
							</div>
						</div>
					</div>
					<div class="chat-helper-srm-item" v-if="JSON.stringify(msgListWithGroup) == '{}'">
						<div class="chat-helper-srm-avatar chat-helper-srm-avatar-d"></div>
						<div class="chat-helper-srm-box">
							<div class="chat-helper-srm-info chat-helper-srm-info-d">
								您好！我是推送助手，我将会把您的消息（包括文本、语音、音频以及视频）打包，一同发送给您选中的好友！
							</div>
						</div>
					</div>
				</div>
				<div class="chat-helper-stsr-groups" id="chat-helper-stsr-groups" v-show="msgIndex !== -1">
					<ul>
						<li v-for="(group,key) in groupObj" @click="msgToGroup(key)" :class="{'chat-helper-stsrg-li-a': key == msgGroup}">{{group}}</li>
					</ul>
					<div @click="initGroupS()">取消</div>
				</div>
			</div>
			<div class="chat-helper-stsr-tools">
				<chat-tools 
					:toolsList='toolList' 
					key="chat-helper-st-ct"
					ref="chatHelperStCt"
					:isFocus='isFocus' 
					@chat-tool-call="chatToolCall($event)">
				</chat-tools>
			</div>
			<div class="chat-helper-stsr-input">
				<chatting-input
					sendButtonId="chat-helper-st-add"
					:chatToolsData="chatToolsData" modifyEnter
					@chat-input-focus="chatInputFocus($event)" 
					@chat-input-msg="chatInputMsg($event)"
					key="chat-helper-st-ci"
					ref="childInput">
				</chatting-input>
			</div>
			<div class="chat-helper-stsr-options">
				<span>按Ctrl+Enter换行</span>
				<span class="chat-helper-stsr-send" @click="addMsg" id="chat-helper-st-add">添加</span>
			</div>
		</div>
		<div class="chat-helper-st-setting">
			<div class="chat-helper-stsg-title">
				相关设置
			</div>
			<div class="chat-helper-stsg-box">
				<div class="chat-helper-stsg-item">
					<label>群发消息置顶</label>
					<ul>
						<li>
							<span class="chat-helper-stsg-select" :class="{'chat-helper-stsg-select-active' : msgToUp}" @click="msgToUpM"></span>
							<span>置顶</span>
						</li>
					</ul>
				</div>
				<div class="chat-helper-stsg-item">
					<label>客服并发发送</label>
					<ul>
						<li>
							<span class="chat-helper-stsg-select" :class="{'chat-helper-stsg-select-active' : fansGroupOpen}" @click="groupOpen"></span>
							<span>启用</span>
						</li>
					</ul>
				</div>
				<div class="chat-helper-stsg-item">
					<label>选择发送方式</label>
					<ul>
						<li>
							<span class="chat-helper-stsg-select" :class="{'chat-helper-stsg-select-active' : sendType === 1}" @click="typeClick(1)"></span>
							<span>以消息为单位发送</span>
						</li>
						<li>
							<span class="chat-helper-stsg-select" :class="{'chat-helper-stsg-select-active' : sendType === 2}" @click="typeClick(2)"></span>
							<span>以好友为单位发送</span>
						</li>
					</ul>
				</div>
				<div class="chat-helper-stsg-item">
					<label>好友时间间隔</label>
					<div class="chat-helper-stsgi-wrap">
						<div class="chat-helper-stsgi-title">间隔时间：</div>
						<div class="chat-helper-stsgi-min">3s</div>
						<div class="chat-helper-stsgi-slider" id="fans-interval"></div>
						<div class="chat-helper-stsgi-max">60s</div>
					</div>
				</div>
				<div class="chat-helper-stsg-item">
					<label>好友消息时间</label>
					<div class="chat-helper-stsgi-wrap">
						<div class="chat-helper-stsgi-title">间隔时间：</div>
						<div class="chat-helper-stsgi-min">3s</div>
						<div class="chat-helper-stsgi-slider" id="msg-interval"></div>
						<div class="chat-helper-stsgi-max">60s</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import ChatTools from '../../../components/ChatTools.vue'
	import ChattingInput from '../../../components/ChattingInput.vue'
	
	export default{
		name:'ChatHelperStepTwo',
		components:{
			ChatTools,
			ChattingInput
		},
		data(){
			return{
				toolList:['emoji','image','video'],
				msgGroup: '',
				msgIndex: -1,
				groupObj:{},
				msgCounter: 0,
				// 消息列表
				msgListWithGroup:{},
				messages:[],
				chatToolsData:{},
				isFocus: 0 ,
				// 其他设置项
				sendType: 1,
				msgMinTime: 3,
				msgMaxTime: 10,
				fansMinTime: 3,
				fansMaxTime: 10,
				fansGroupOpen: false,
				msgToUp: true
			}
		},
		methods:{
			// 初始化部分数据
			init(){
				this.msgGroup = ''
				this.msgIndex = -1
				this.groupObj = {}
				this.msgCounter = 0
				this.msgListWithGroup = {}
				this.messages = []
				this.isFocus = 0
				this.sendType = 1
				this.msgMinTime = 3
				this.msgMaxTime = 10
				this.fansMinTime = 3
				this.fansMaxTime = 10	
				this.fansGroupOpen = false
			},
			
			// 初始化分组数据
			initGroupS(){
				this.msgIndex = -1
				this.msgGroup = ''
			},
			
			// 发送方式选择点击
			typeClick(type){
				if(type == this.sendType){
					return
				}
				this.sendType = type
				this.emitMsg()
			},
			
			// 是否并发发送
			groupOpen(){
				this.fansGroupOpen = !this.fansGroupOpen
				this.emitMsg()
			},
			
			// 群发消息是否置顶-跳转到聊天页面最上面
			msgToUpM(){
				this.msgToUp = !this.msgToUp
				this.emitMsg()
			},
			
			// 消息删除
			delMsg(key,index){
				this.msgListWithGroup[key].splice(index,1)
				// 循环判断有没有空的分组，如果有，则删除空的分组
				for(let i in this.msgListWithGroup){
					if(this.msgListWithGroup[i].length === 0){
						delete this.msgListWithGroup[i]
						delete this.groupObj[i]
					}
				}
				this.emitMsg()
			},
			
			// 添加待群发的消息
			addMsg(){
				for (let i = 0; i < this.messages.length; i++) {
					this.msgCounter++
					// 添加分组
					let gourp = 'G'+(this.msgCounter)
					if(!this.groupObj.hasOwnProperty(gourp)){
						this.groupObj[gourp] = gourp
					}
					// 将消息进行分组
					if(!this.msgListWithGroup.hasOwnProperty(gourp)){
						let msgListTemp = [this.messages[i]]
						this.$set(this.msgListWithGroup,gourp,msgListTemp)
					}else{
						this.msgListWithGroup[gourp].push(this.messages[i])
					}
				}
				this.messages = []
				this.$refs.childInput.clearInput()
				this.$refs.chatHelperStCt.currentTools = ''
				this.chatToolsData = {}
				this.emitMsg()
				// 滚动条下移
				this.$nextTick(()=>{
					let page = document.getElementById("chat-helper-stsr-msg")
					if(page !== null && page !== undefined){
						page.scrollTop = page.scrollHeight + page.clientHeight
					}
				})
			},
			
			// 输入框聚焦回调
			chatInputFocus(data){
				this.isFocus = parseInt(data)
			},
			
			// 数据框消息更改回调
			chatInputMsg(data){
				this.messages = data
			},
			
			// 监听工具栏的数据回调
			chatToolCall(data){
				this.chatToolsData = data
			},
			
			// 分组选择点击
			selectGroup(event,key,index) {
				// 判断当前操作对象是否为自己，如果是则关闭
				if (this.msgIndex != -1 && this.msgGroup == key && this.msgIndex == index) {
					this.initGroupS()
					return
				}
				// 定位
				var menu = document.querySelector("#chat-helper-stsr-groups")
				// LEFT距离计算
				let offsetX = event.clientX - 100
				// 计算TOP值
				let offSetY = event.clientY - 210
				menu.style.left = offsetX + 'px'
				menu.style.top = offSetY + 'px'
				this.msgIndex = index
				this.msgGroup = key
			},
			
			// 消息分组
			msgToGroup(groupKey){		
				if(this.msgListWithGroup[this.msgGroup] === undefined){
					return
				}
				let msg = this.msgListWithGroup[this.msgGroup][this.msgIndex]
				if(msg === undefined){
					return
				}
				if(groupKey == this.msgGroup){
					this.initGroupS()
					return
				}
				msg = JSON.parse(JSON.stringify(msg))
				this.msgListWithGroup[groupKey].push(msg)
				// 删除当前分组里面的元素信息
				this.msgListWithGroup[this.msgGroup].splice(this.msgIndex,1)
				// 循环判断有没有空的分组，如果有，则删除空的分组
				for(let i in this.msgListWithGroup){
					if(this.msgListWithGroup[i].length === 0){
						delete this.msgListWithGroup[i]
						delete this.groupObj[i]
					}
				}
				this.initGroupS()
				this.emitMsg()
			},
			
			// 重设参数
			reset(){
				this.init()
				this.emitMsg()
			},
			
			// 向父级反射数据
			emitMsg(){
				// 重新整理消息数据
				let msgList = []
				for(let i in this.msgListWithGroup){
					msgList.push(this.msgListWithGroup[i])
				}
				this.$emit('sender-msg-call',{
					msgList: msgList,
					sendType: this.sendType,
					msgMinTime: this.msgMinTime,
					msgMaxTime: this.msgMaxTime,
					fansMinTime: this.fansMinTime,
					fansMaxTime: this.fansMaxTime,
					fansGroupOpen:this.fansGroupOpen,
					msgToUp: this.msgToUp
				})
			}
		},
		mounted() {
			let _this = this
			// layui组件-滑块-好友时间间隔
			layui.use('slider',function(){
				let slider = layui.slider
				slider.render({
					elem:'#fans-interval',
					type: 'default',
					min: 3,
					max: 60,
					range: true,
					value: [3,10],
					change:function(value){
						_this.fansMinTime = value[0]
						_this.fansMaxTime  =value[1]
						_this.emitMsg()
					}
				})
			})
			
			// layui组件-滑块-好友消息时间
			layui.use('slider',function(){
				let slider = layui.slider
				slider.render({
					elem:'#msg-interval',
					type: 'default',
					min: 3,
					max: 60,
					range: true,
					value: [3,10],
					theme: "#2fc4dc",
					change:function(value){
						_this.msgMinTime = value[0]
						_this.msgMaxTime  =value[1]
						_this.emitMsg()
					}
				})
			})
		},
		computed:{
			msgCounterInfo(){
				let msgCount = 0
				let groupCount = 0
				for(let i in this.msgListWithGroup){
					groupCount++
					for (var j = 0; j < this.msgListWithGroup[i].length; j++) {
						msgCount++
					}
				}
				return {
					msgCount,
					groupCount
				}
			}
		}
	}
</script>

<style>
	.chat-helper-st-container{
		width: 100%;
		height: 100%;
		position: relative;
		overflow: hidden;
		padding: 0 10px;
		box-sizing: border-box;
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
	}
	.chat-helper-st-container .chat-helper-st-sender{
		width: 60%;
		height: 100%;
		border-top: 1px solid #e1e1e1;
		border-right: 1px solid #e1e1e1;
		border-bottom: 1px solid #e1e1e1;
		box-sizing: border-box;
		position: relative;
	}
	.chat-helper-st-sender .chat-helper-stsr-title{
		height: 50px;
		display: flex;
		justify-content: space-between;
	}
	.chat-helper-stsr-title .chat-helper-stsr-desc{
		text-indent: 5px;
		line-height: 50px;
	}
	.chat-helper-stsr-desc span{
		color: #009E94;
		font-weight: bold;
		text-align: center;
	}
	.chat-helper-stsr-desc span:last-child{
		color: #ff0000;
	}
	.chat-helper-stsr-title .chat-helper-stsr-reset{
		padding: 14px;
	}
	.chat-helper-stsr-reset button{
		background-color: #007DDB;
		color: #FFFFFF;
		height: 26px;
		padding: 0 10px;
		cursor: pointer;
		border-radius: 2px;
	}
	.chat-helper-st-sender .chat-helper-stsr-msg-box{
		position: absolute;
		top: 50px;
		bottom: 200px;
		left: 0;
		right: 0;
		border-top: 1px solid #e1e1e1;
		border-bottom: 1px solid #e1e1e1;
	}
	.chat-helper-stsr-msg-box .chat-helper-stsr-msg{
		position: relative;
		overflow-x: hidden;
		overflow-y: auto;
		height: 100%;
	}
	.chat-helper-stsr-msg .chat-helper-srm-item{
		padding: 10px 5px;
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		flex-wrap: nowrap;
	}
	.chat-helper-srm-item .chat-helper-srm-group{
		height: 36px;
		vertical-align: top;
		margin-right: 4px;
		font-size: 12px;
		user-select: none;
		position: relative;
		font-family: cursive;
		text-align: center;
	}
	.chat-helper-srm-group > div{
		height: 18px;
		line-height: 18px;
		padding: 0 10px;
	}
	/* 原始分组样式 */
	.chat-helper-srm-group .chat-helper-srmg-name{
		background-color: #a2e9ff;
		color: #666666;
		border-radius: 2px 2px 0 0;
	}
	.chat-helper-srm-group .chat-helper-srmg-select{
		background-color: #ccf0fb;
		color: #333333;
		cursor: pointer;
		border-radius: 0 0 2px 2px;
	}
	/* 分组样式1-G1样式 */
	.chat-helper-srm-group-1>.chat-helper-srmg-name{
		background-color: #ffc530;
	}
	.chat-helper-srm-group-1>.chat-helper-srmg-select{
		background-color: #ffe9af;
	}
	/* 分组样式1-G2样式 */
	.chat-helper-srm-group-2>.chat-helper-srmg-name{
		background-color: #a0ff30;
	}
	.chat-helper-srm-group-2>.chat-helper-srmg-select{
		background-color: #e2ffc0;
	}
	/* 分组样式G3样式 */
	.chat-helper-srm-group-3>.chat-helper-srmg-name{
		background-color: #ff9a59;
	}
	.chat-helper-srm-group-3>.chat-helper-srmg-select{
		background-color: #ffe5d5;
	}
	/* 分组样式G4样式 */
	.chat-helper-srm-group-4>.chat-helper-srmg-name{
		background-color: #30ffd5;
	}
	.chat-helper-srm-group-4>.chat-helper-srmg-select{
		background-color: #befff2;
	}
	/* 分组样式G5样式 */
	.chat-helper-srm-group-5>.chat-helper-srmg-name{
		background-color: #30ddff;
	}
	.chat-helper-srm-group-5>.chat-helper-srmg-select{
		background-color: #cbf6ff;
	}
	/* 分组样式G6样式 */
	.chat-helper-srm-group-6>.chat-helper-srmg-name{
		background-color: #ffb2f7;
	}
	.chat-helper-srm-group-6>.chat-helper-srmg-select{
		background-color: #ffe6fc;
	}
	/* 分组样式G7样式 */
	.chat-helper-srm-group-7>.chat-helper-srmg-name{
		background-color: #a4a0ff;
	}
	.chat-helper-srm-group-7>.chat-helper-srmg-select{
		background-color: #e9e9ff;
	}
	/* 分组样式G8样式 */
	.chat-helper-srm-group-8>.chat-helper-srmg-name{
		background-color: #ffa998;
	}
	.chat-helper-srm-group-8>.chat-helper-srmg-select{
		background-color: #ffded8;
	}
	/* 分组样式G9样式 */
	.chat-helper-srm-group-9>.chat-helper-srmg-name{
		background-color: #30ff6c;
	}
	.chat-helper-srm-group-9>.chat-helper-srmg-select{
		background-color: #cbffda;
	}
	.chat-helper-srm-item .chat-helper-srm-avatar{
		width: 36px;
		height: 36px;
		background-image: url(../../../assets/img/default_wechat_icon.png);
		background-position: center;
		background-size: 36px auto;
		background-repeat: no-repeat;
		margin-right: 10px;
	}
	.chat-helper-srm-avatar-d{
		background-image: url(../../../assets/img/comp-helper-active.png) !important;
		background-size: 28px auto !important;
	}
	.chat-helper-srm-item .chat-helper-srm-box{
		flex-grow: 1;
		width: 0;
		position: relative;
	}
	.chat-helper-srm-box .chat-helper-srm-info{
		background-color: #b2e281;
		padding: 6px;
		border-radius: 2px;
		line-height: 26px;
		color: #424242;
		position: relative;
		max-width: 60%;
		display: inline-block;
		vertical-align: middle;
		word-break: break-all;
	}
	.chat-helper-srm-info::after{
		display: block;
		content: '';
		position: absolute;
		top: 10px;
		left: -5px;
		width: 10px;
		height: 10px;
		background-color: #b2e281;
		transform: rotateZ(45deg);
	}
	.chat-helper-srm-info img{
		max-width: 300px;
		height: auto;
	}
	.chat-helper-srm-info video{
		background-color: #FFFFFF;
		outline: none;
		display: block;
		max-width: 300px;
		height: auto !important;
	}
	.chat-helper-srm-box .chat-helper-srm-info-d{
		background-color: #EEEEEE !important;
	}
	.chat-helper-srm-info-d::after{
		background-color: #EEEEEE !important;
	}
	.chat-helper-srm-box:hover .chat-helper-srm-del{
		width: 18px;
		height: 18px;
		display: inline-block;
		vertical-align: middle;
		margin-left: 10px;
		cursor: pointer;
		background-image: url(../../../assets/img/delete-red-32.png);
		background-position: center;
		background-size: cover;
	}
	.chat-helper-stsr-msg-box .chat-helper-stsr-groups{
		position: absolute;
		top: 0;
		left: 10px;
		background-color: #404040;
		cursor: pointer;
		font-size: 12px;
		border-radius: 2px;
		color: #EEEEEE;
		z-index: 2;
		padding: 2px;
	}
	.chat-helper-stsr-groups ul{
		max-height: 192px;
		overflow-y: auto;
		overflow-x: hidden;
	}
	.chat-helper-stsr-groups ul li{
		padding: 5px 20px;
	}
	.chat-helper-stsr-groups ul li:hover{
		background-color: #9e9e9e;
	}
	.chat-helper-stsr-groups>div{
		background-color: red;
		text-align: center;
		line-height: 24px;
		margin-top: 2px;
	}
	.chat-helper-stsr-groups ul .chat-helper-stsrg-li-a{
		background-color: #9e9e9e;
	}
	.chat-helper-st-sender .chat-helper-stsr-tools{
		position: absolute;
		left: 0;
		right: 0;
		bottom: 150px;
		height: 50px;
	}
	.chat-helper-stsr-tools>.comp-c-tools{
		padding: 0 !important;
	}
	.chat-helper-stsr-tools>.comp-c-tools>.comp-c-tools-emoji-box{
		left: 6px;
	}
	.chat-helper-stsr-tools>.comp-c-tools>.comp-c-tools-image-box{
		left: 50px;
	}
	.chat-helper-stsr-tools>.comp-c-tools>.comp-c-tools-video-box{
		left: 48px;
	}
	.chat-helper-st-sender .chat-helper-stsr-input{
		position: absolute;
		left: 0;
		right: 0;
		bottom: 40px;
		height: 110px;
		padding: 0 10px;
	}
	.chat-helper-stsr-input .chat-helper-stsr-teaxarea{
		border: 1px solid #e1e1e1;
		height: 100%;
		padding: 10px;
		box-sizing: border-box;
		outline: none;
		border-radius: 4px;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.chat-helper-stsr-teaxarea:focus{
		border: 1px solid #42B983;
	}
	.chat-helper-st-sender .chat-helper-stsr-options{
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		height: 40px;
		padding: 0 10px;
		line-height: 40px;
		text-align: right;
	}
	.chat-helper-stsr-options span{
		display: inline-block;
		vertical-align: middle;
	}
	.chat-helper-stsr-options .chat-helper-stsr-send{
		margin-left: 10px;
		background-color: #42B983;
		color: #FFFFFF;
		height: 26px;
		line-height: 26px;
		padding: 0 10px;
		border-radius: 2px;
		cursor: pointer;
	}
	.chat-helper-st-setting{
		width: 40%;
		height: 100%;
		border-top: 1px solid #e1e1e1;		border-bottom: 1px solid #e1e1e1;
		position: relative;
		box-sizing: border-box;
		user-select: none;
	}
	.chat-helper-st-setting .chat-helper-stsg-title{
		padding: 0 10px;
		line-height: 50px;
	}
	.chat-helper-st-setting .chat-helper-stsg-box{
		border-top: 1px solid #e1e1e1;
	}
	.chat-helper-stsg-box .chat-helper-stsg-item{
		padding: 10px;
	}
	.chat-helper-stsg-item label{
		display: block;
		width: 100%;
		margin-bottom: 10px;
		color: #999999;
	}
	.chat-helper-stsg-item ul{
		width: 100%;
		height: 30px;
		overflow: hidden;
	}
	.chat-helper-stsg-item ul li{
		width: 170px;
		height: 30px;
		line-height: 30px;
		display: inline-block;
		vertical-align: middle;
	}
	.chat-helper-stsg-item ul li span{
		display: inline-block;
		vertical-align: middle;
	}
	.chat-helper-stsg-select{
		width: 30px;
		height: 30px;
		background-image: url(../../../assets/img/select-out.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 18px;
		cursor: pointer;
	}
	.chat-helper-stsg-select-active{
		background-image: url(../../../assets/img/select-in.png) !important;
	}
	.chat-helper-stsg-item .chat-helper-stsgi-wrap{
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.chat-helper-stsgi-wrap .chat-helper-stsgi-title{
		width: 72px;
	}
	.chat-helper-stsgi-min,.chat-helper-stsgi-max{
		width: 26px;
		margin: 0 7px;
		text-align: center;
	}
	.chat-helper-stsgi-wrap .chat-helper-stsgi-slider{
		flex-grow: 1;
		width: 0;
	}
</style>
